import { SnackService } from './snacks.service';
import { UtilityService } from './utility.service';
import { Injectable } from "@angular/core";

@Injectable()
export class ShareService {
  constructor(
    private utilityService: UtilityService,
    private snackService: SnackService,
  ) { }

  shareWhatsapp(numero: string, blank = true, customText?: string) {
    const mobile = this.utilityService.isMobile();
    if (mobile) {
      window.open(
        this.returnWhatsappApp(numero, customText),
        blank ? "_blank" : ""
      );
    } else {
      window.open(
        this.returnWhatsappWeb(numero, customText),
        blank ? "_blank" : ""
      );
    }
  }
  returnWhatsappApp(numero: string, title: string) {
    return `https://wa.me/${numero}?text=${title}`;
  }
  returnWhatsappWeb(numero: string, title: string) {
    return `https://web.whatsapp.com/send?phone=${numero}&text=${title}`;
  }

  shareFacebook(
    url: string,
    descripcion: string,
    imagenRedI: string,
    blank = true
  ) {
    window.open(
      this.returnFacebook(url, descripcion, imagenRedI),
      blank ? "_blank" : ""
    );
  }
  shareTwitter(url: string, blank = true) {
    window.open(this.returnTwitter(url), blank ? "_blank" : "");
  }

  returnFacebook(url: string, descripcion: string, imagen: string) {
    return `https://www.facebook.com/sharer/sharer.php?u=${url}&amp;t=${descripcion}&amp;src=${imagen}`;
  }
  returnTwitter(url: string) {
    return `https://twitter.com/intent/tweet?original_referer=${url}&ref_src=${url}&tw_p=tweetbutton&url=${url}`;
  }
  shareCopy(url: string, customTitle = "") {
    let button: string;
    navigator.clipboard.writeText(url);
    let title = "";
    if (customTitle) {
      title = customTitle;
      button = "Aceptar"
    } else {
      title = 'El enlace fue copiado con éxito.';
      button = "Aceptar"
    }
    this.snackService.openSnackAlert(
      1000,
      {
        button,
        descripcion: title,
        icon: "done_all",
        color: "primary",
      },
      "end",
      "bottom"
    );
  }

}
